import { TooltipProps } from 'react-tooltip';
import Tooltip from '@sdk/common/tooltip/Tooltip';
import styled from 'styled-components';

import InfoIconSvg from '../assets/svg/Icons/16/info-gray.svg';

const Clickable = styled.div`
  cursor: pointer;
  display: flex;
  margin-left: 5px;
`;

const InfoIcon = styled(InfoIconSvg)`
  &:not(:hover) {
    opacity: 0.8;
  }

  outline: none;
`;

type Props = {
  tip: string;
  attachToBody?: boolean;
} & TooltipProps;

const InfoTooltip = ({ tip, place = 'right', attachToBody = true, ...props }: Props) => {
  return (
    <Clickable>
      <InfoIcon data-tip={tip} data-place={place} />
      <Tooltip attachToBody={attachToBody} {...props} />
    </Clickable>
  );
};

export default InfoTooltip;
